<template>
  <div>
    <van-nav-bar
      title="意见建议"
      left-text="返回"
      @click-left="onClickLeft"
      left-arrow
      right-text="主页"
      @click-right="handleHome"
    />

    <div class="app-container">
      <van-cell-group inset>
        <van-cell
          title="反映人"
          :value="form.lxrxm"
        />
        <template>
          <van-cell
            v-if="form.lxfs"
            title="反映人联系手机"
            :value="form.lxfs"
          />
          <van-cell
            v-else
            title="反映人联系手机"
            value="暂无"
          />
        </template>
        <van-cell
          title="所属地区"
          :value="area"
        />
        <van-cell
          :title="title"
          :value="name"
        />
      </van-cell-group>
      <van-form class="form-bar" @submit="onSubmit">
        <van-field
          v-model="form.yjnr"
          rows="4"
          autosize
          type="textarea"
          maxlength="800"
          show-word-limit
          required
          label="意见内容"
          placeholder="请输入内容"
        />
        <div class="upload-bar">
          <van-uploader
            v-model="files"
            ref="uploader"
            accept="image/*"
            :max-size="15 * 1024 * 1024"
            :max-count="3"
            style="margin-left: 0.7rem;"
          />
          <van-notice-bar
            wrapable
            :scrollable="false"
            text="请上传png，jpg，jpeg格式的图片，最多上传三张"
          />
        </div>
        <div style="margin: 16px;">
          <van-button
            round
            block
            type="info"
            native-type="submit"
          >提 交</van-button>
        </div>
      </van-form>
      <van-radio-group class="radio-bar" v-model="radio">
        <van-checkbox v-model="checked" ></van-checkbox>
        <span @click="handleKnow">留言须知</span>
      </van-radio-group>
    </div>
    <van-popup
      v-model="radioShow1"
      position="bottom"
      :style="{ height: '60%' }"
      closeable
      close-icon-position="bottom-left"
    >
      <p style="padding: 1rem; font-size: 16px;">
        人民群众留言须知
        <br>
        一、人大代表不直接处理具体问题，主要收集辖区内需要一定时间深入调研的公共性、宏观性、各方观点的民情民意。群众留言分咨询与建议两类，包括与人大代表、人大工作有关的咨询，以及经政府等职能部门处理后，未落实的民生类公共问题的合理意见建议。人大代表了解有关情况后可以直接回复群众；或者转交职能部门办理答复；或者综合同类事项的不同群众意见后，作为代表议事会的议题、向人大代表大会提交代表议案建议和审议相关部门工作报告的素材。
        <br>
        二、人民群众应当围绕政治、经济、文化、社会和生态文明建设中需要深入研究的重要问题以及人民群众普遍关心的民生问题提出意见、建议，也可以对自己直接或间接选举产生的人大代表的履职情况提出意见。
        <br>
        三、群众反映的问题如属于政府等职能部门的职能，建议先通过信访、司法或12345热线等渠道反映。涉及生命财产安全的特别紧急问题，建议通过拨打110、120电话等紧急应对部门电话的方式解决。职能部门如未积极落实合理诉求，可向人大代表反映，反映情况时须附上职能部门办理情况。比如咨询政府职责范围的起诉、公积金、社保、公交、地铁、火车等一般业务性问题，建议先通过12345热线等渠道反映；但如果群众提出的是公积金、社保、交通等公共性的政策问题，政府已反馈，未采纳未落实的，人大代表可以研究群众意见是否合理，合理的可以通过代表联系函等方式转办。如反映的问题属于人大职能范围的立法建议、监督等工作，也可以直接反映。
        <br>
        四、如果所反映问题属于辖区的事情，请按照该问题涉及职能部门的级别，向该问题所在辖区联络站的各级人大代表反映；问题属于区国家机关和有关单位、组织办理的事项，向区人大代表反映（市及市级以上人大代表可以联名）；属于市级国家机关和有关单位、组织办理的事项，向市及市级以上人大代表反映。经人大代表研究，有必要的可以转交职能部门办理。
        <br>
        五、下列情况不应当向代表反映：
        <br>
        •  （一）属于本人、亲属的事务或者其他个人问题的。
        <br>
        •  （二）属于申诉、控告、检举的事务。
        <br>
        •  （三）属于法律咨询、政策咨询、学术探讨、产品推介、问卷调查和投票的。
        <br>
        •  （四）可能与个人利益存在关联或者干涉正常经济活动和市场主体公平竞争的。
        <br>
        •  （五）重复留言或内容空泛、笼统、没有具体内容的。
        <br>
        •  （六）正处于侦查、起诉、审理等涉法涉诉的案件和重复信访的问题。
        <br>
        •  （七）不属于绍兴市事权的事务或需交由绍兴市以外的有关单位和部门办理的事务。
        <br>
        •  （八）违反有关法律法规的，内容捏造或者歪曲事实，散布谣言，侮辱、诽谤、诋毁他人，破坏他人名誉的，或是编造、转发危害国家安全、淫秽色情、封建迷信等有害信息的。
        <br>
        六、人民群众向代表留言，建议登记本人联系方式，便于联系反馈。
        <br>
        七、人大代表收到人民群众留言后，将会及时按照有关规定处理。回复留言仅代表人大代表个人，发挥专业所长，起到帮助群众，居中协调、督促落实的作用。对于转交联系函后仍然无法解决的合理问题，人大代表可以采取提交代表议案、代表建议，或者在相关会议、活动等场合反映情况的形式推动解决。如在参加人民代表大会审议工作报告、座谈会、代表议事会时提出相关意见、建议。
      </p>
      <!-- <p style="padding-right: 0;">{{time}}s</p> -->
      <div style="margin: 16px">
        <van-button round block type="primary" @click="handleClose" :disabled = "disabled">
          {{buttonContent}}
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { isStringNull } from '@/utils/isvalue.js'
import request from '@/api/getLLZ.js'
import axios from 'axios'
export default {
  data () {
    return {
      title: '联系代表',
      name: '',
      time: 10,
      radio: null,
      radioShow: false,
      radioShow1: false,
      disabled: false,
      buttonContent: '关闭',
      form_label_width: '70px',
      preservationTap: false,
      form: {},
      dbName: this.$route.query.dbName || '',
      llzName: this.$route.query.llzName || '',
      file_list: [],
      area: '',
      checked: false,
      files: []
    }
  },
  created () {
    if (this.$route.query.llzName) {
      this.title = '联系联络站'
    }
    this.getUserinfo()
  },
  methods: {
    handleKnow () {
      this.radioShow = !this.radioShow
      this.radioShow1 = !this.radioShow1
      if (this.radioShow) {
        this.radio = null
      } else {
        this.radio = '1'
      }
    },
    handleClose () {
      this.radio = '1'
      this.radioShow1 = false
    },
    handleBack () {
      this.$router.go(-1)
    },
    handleHome () {
      this.$router.push('/home')
    },
    async getUserinfo () {
      const queryParams = {
        openid: localStorage.getItem('openid'),
        pageIndex: 1,
        pageSize: 200

      }
      if (this.$route.query.dbName) {
        queryParams.dbName = this.$route.query.dbName
        queryParams.dbId = this.$route.query.id
      } else {
        queryParams.llzId = this.$route.query.id
      }
      const res = await request.getUserInfo(queryParams)
      this.area = res.ssqx + '-' + res.ssxzjd
      this.form = res
      if (this.$route.query.llzName) {
        this.form.llzid = this.$route.query.id
        this.name = this.$route.query.llzName
      } else {
        this.name = this.form.dbname
      }
    },
    async onSubmit () {
      this.form.yjlx = 1
      this.form.sfhf = 1
      if (!this.checked) {
        this.$toast.fail('请选择留言须知')
        return
      }
      if (this.form.sfktj !== undefined) {
        this.$toast.fail('您今天已经提过建议了，谢谢您的建议（每天只能提一次）')
        return
      }
      if (!isStringNull(this.form.yjnr)) {
        this.$toast.fail('请输入意见内容')
        return
      }
      this.$toast.loading({
        duration: 0, // 持续时间，0表示持续展示不停止
        forbidClick: true, // 是否禁止背景点击
        message: '提交中' // 提示消息
      })
      // 附件上传
      const url = this.$url + 'api/common/file/uploadForPicture'
      console.log(9999999888, this.files)
      const files = this.files.map(m => {
        const formData = new FormData()
        formData.append('file', m.file)
        return formData
      })
      const config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      let result = null
      try {
        result = await Promise.all(files.map(async m => {
          const res = await axios.post(url, m, config)
          return res
        }))
      } catch (error) {
        return this.$toast.fail('上传失败')
      }
      try {
        const filesId = result.map(m => m.data.data.id).join(',')
        this.form = { ...this.form, files: filesId }
        await request.addPeopleText(this.form)
        this.$toast.success('提交成功')
        this.$router.push('/home')
      } catch (error) {
        this.$toast.fail('提交失败')
      }
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    handleAvatarSuccess (res, file) {
      if (res.data) {
        this.form.yjfj = res.data
        console.log(this.file_list)
        this.file_list = []
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type.indexOf('image') !== -1
      const isLt2M = file.size / 1024 / 1024 < 5

      if (!isJPG) {
        this.$message.error('您上传的不是正确的图片格式')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 5MB!')
      }
      return isJPG && isLt2M
    },
    // 提交表单
    handleSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          this.preservationTap = true
          request.addSug(this.form, this.$route.query.type).then(res => {
            if (res) {
              this.$router.push({
                path: '/callback'
              })
            }
            this.preservationTap = false
          }).catch(err => {
            this.$message({
              type: 'error',
              message: err
            })
            this.preservationTap = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialogTitle {
  margin-bottom: 0;
}
.app-container {
  position: relative;
  background-color: #eee;
  background: url('../../../assets/images/yjjy_publish.jpg') no-repeat;
  background-size: 100% auto;
  padding: 250px 10px 20px;
  .content-wrap {
    background-color: #fff;
    padding: 10px 15px;
    border-radius: 10px;
  }
  .radio-bar{
    display: flex;
    justify-content: center;
    span{
      font-size: 28px;
    }
  }
  .form-item {
    border-bottom: 1px solid #efefef;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      flex: 0 0 120px;
    }
    /deep/.site .el-input__inner,
    /deep/.handle_type .el-input__inner {
      text-align: right;
    }
    /deep/ .el-input__inner {
      padding-left: 0;
    }
    .site {
      text-align: right;
    }
  }
  .form-item2 {
    border-bottom: 1px solid #efefef;
    padding: 10px 0;
    div {
      padding-bottom: 10px;
    }
    /deep/.el-textarea__inner {
      padding-left: 0;
      border: none;
    }
  }
  /deep/.el-input__inner {
    border: none;
  }
  .form-bar{
    .upload-bar{
      padding: 20px;
    }
    /deep/.van-cell{
      padding: 0 60px;
    }
  }
}
/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
.btn-group {
  text-align: center;
  .el-button {
    display: block;
    width: 100%;
  }
}
.db_info,
.llz_info {
  .form-item {
    border: none;
  }
}
/deep/.van-field__label {
  color: #323233;
}
/deep/ .van-radio{
  justify-content: center;
  font-size: 3.733333vw;
}
.goBack {
  position: fixed;
  bottom: 100px;
  right: 50px;
  width: 120px;
  height: 120px;
  text-align: center;
  line-height: 130px;
  background-color: #1989fa;
  border-radius: 50%;
  font-size: 50px;
  color: #fff;
}
.goHome {
  right: 200px;
}
</style>
